import { Amount } from '@model/common';
import React from 'react';
import { FromPrice } from '@components/basket/v1/labels';
import { TourDossiers } from '@components/product/tour-dossiers/TourDossiers';
import styled from '@emotion/styled';
import { breakpoints, mq } from '@styles/breakpoints';
import { TourDossier } from '@model/tours';
import { Price } from '@model/common';
import { ButtonVariant } from '@components/material-ui';
import { BasketPanelContainer } from '@components/basket/v1/basket-panel/BasketPanelContainer';
import { SkeletonElement, SkeletonVariant } from '@components/common/skeleton-loading';
import { ThemeProps } from '@theme/base';
import { useMedia } from 'react-use';

export interface ToursBasketPanelProps {
  price?: Price;
  onClick: () => void;
  top?: number;
  dossiers: Array<TourDossier> | null;
  isGhosting?: boolean;
  dossiersGhosting?: boolean;
}

const ToursBasketPanelContainer = styled(BasketPanelContainer)({
  ['[class*="ActionButton"]']: {
    [mq.medium]: {
      marginTop: '0'
    }
  }
});

const RenderContainer: any = styled.div({
  width: '100%'
});

const Dossiers = styled(TourDossiers)({
  display: 'none',
  [mq.medium]: {
    display: 'flex'
  }
});

const PriceSkeleton: any = styled(SkeletonElement)(({ theme }: ThemeProps) => ({
  width: '100%',
  marginBottom: theme.custom.spacing.small,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.large
  }
}));

export const TourBasketPanel = ({
  price,
  onClick,
  top,
  dossiers,
  isGhosting,
  dossiersGhosting
}: ToursBasketPanelProps) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.medium}px)`);

  return (
    <ToursBasketPanelContainer
      labels={{ desktop: 'tours__basket-panel--desktop', mobile: 'tours__basket-panel--mobile' }}
      onClick={onClick}
      isTour
      render={
        <RenderContainer>
          {price ? (
            <FromPrice
              label={'common__per-person--label'}
              price={new Amount(price.amount, price.currency.code)}
              title={'price__label--from'}
            />
          ) : isGhosting ? (
            <PriceSkeleton variant={SkeletonVariant.RECTANGLE} width={'100%'} height={50} />
          ) : null}
        </RenderContainer>
      }
      top={top}
      buttonVariant={ButtonVariant.OUTLINED}
    >
      {!isMobile &&
        (dossiers?.length && !dossiersGhosting ? (
          <Dossiers dossiers={dossiers} />
        ) : (
          dossiersGhosting && <SkeletonElement variant={SkeletonVariant.RECTANGLE} width="100%" />
        ))}
    </ToursBasketPanelContainer>
  );
};
